// Per-sport stat catalogs that drive the admin game-stats form columns.
// Mirror of the SPORT_STAT_KEYS allowlist in
// ios/Lambda/polyp-admin-match-stats/index.mjs — keep the two in sync.
//
// Each sport is an ordered list of { key, label, abbr, group }. `key` is the
// schemaless map key persisted on the PlayerGameStats row; `abbr` is the compact
// column header; `group` lets the UI cluster related columns.

export const SPORT_STATS = {
  basketball: [
    { key: "points", label: "Points", abbr: "PTS", group: "scoring" },
    { key: "fgMade", label: "Field goals made", abbr: "FGM", group: "shooting" },
    { key: "fgAttempted", label: "Field goals attempted", abbr: "FGA", group: "shooting" },
    { key: "threePtMade", label: "3-pointers made", abbr: "3PM", group: "shooting" },
    { key: "threePtAttempted", label: "3-pointers attempted", abbr: "3PA", group: "shooting" },
    { key: "ftMade", label: "Free throws made", abbr: "FTM", group: "shooting" },
    { key: "ftAttempted", label: "Free throws attempted", abbr: "FTA", group: "shooting" },
    { key: "offReb", label: "Offensive rebounds", abbr: "OREB", group: "rebounds" },
    { key: "defReb", label: "Defensive rebounds", abbr: "DREB", group: "rebounds" },
    { key: "assists", label: "Assists", abbr: "AST", group: "playmaking" },
    { key: "steals", label: "Steals", abbr: "STL", group: "defense" },
    { key: "blocks", label: "Blocks", abbr: "BLK", group: "defense" },
    { key: "turnovers", label: "Turnovers", abbr: "TO", group: "playmaking" },
    // "fouls" is every foul charged to the player — personal, technical and
    // flagrant alike — because NFHS counts all three toward the five-foul
    // disqualification the iOS live tracker enforces. The two keys below are
    // subsets of it, not additions, so never sum PF + TF + FF.
    { key: "fouls", label: "Personal fouls", abbr: "PF", group: "defense" },
    { key: "technicalFouls", label: "Technical fouls", abbr: "TF", group: "defense" },
    { key: "flagrantFouls", label: "Flagrant fouls", abbr: "FF", group: "defense" },
    { key: "minutes", label: "Minutes played", abbr: "MIN", group: "playing-time" },
  ],
  // Stubbed for future youth-soccer academies — no UI exposure yet.
  soccer: [
    { key: "goals", label: "Goals", abbr: "G", group: "scoring" },
    { key: "assists", label: "Assists", abbr: "A", group: "scoring" },
    { key: "shots", label: "Shots", abbr: "SH", group: "attacking" },
    { key: "shotsOnTarget", label: "Shots on target", abbr: "SOT", group: "attacking" },
    { key: "saves", label: "Saves", abbr: "SV", group: "goalkeeping" },
    { key: "goalsAllowed", label: "Goals allowed", abbr: "GA", group: "goalkeeping" },
    { key: "foulsCommitted", label: "Fouls committed", abbr: "FC", group: "discipline" },
    { key: "yellowCards", label: "Yellow cards", abbr: "YC", group: "discipline" },
    { key: "redCards", label: "Red cards", abbr: "RC", group: "discipline" },
    { key: "minutes", label: "Minutes played", abbr: "MIN", group: "playing-time" },
  ],
};

// Sports exposed in the admin form's sport dropdown today.
export const ACTIVE_SPORTS = ["basketball"];

export const DEFAULT_SPORT = "basketball";
